var LoginCta              = require("./LoginCta"),
    PageBackgroundSupport = require("app/ui/PageBackgroundSupport"),
    PopupLayout           = require("app/AppLayout/PopupLayout"),
    ScrollerPopup         = require("app/ui/ScrollerPopup"),
    SignUpCta             = require("./SignUpCta"),
    ImageOptimizerSupport = require("app/ui/ImageOptimizerSupport"),
    closeButtonThemeVars  = require("app/theme/IconButtonVariables--close"),
    kind                  = require("enyo/kind"),
    themeVars             = require("app/theme/variables.js");

require("./UserRequiredMessage.less");
require("app/theme/styles/popups/ScrollerPopup--bordered.less");

module.exports = kind(/** @lends  app.Bookmarks.UserRequiredMessage.prototype */ {

    /**
     * @private
     */
    name: "app.Bookmarks.UserRequiredMessage",

    /**
     * @private
     */
    kind: ScrollerPopup,

    /**
     * @private
     */
    mixins: [
        ImageOptimizerSupport,
        PageBackgroundSupport
    ],

    /**
     * @private
     */
    classes: "app-bookmarks-user-required-message",

    /**
     * @private
     */
    layoutKind: PopupLayout,

    /**
     * @private
     */
    layoutOptions: {
        alignment:       "fullLayout",
        expand:          false,
        overlapSafeArea: false,

        /**
         * @returns {number} The margin in pixels
         */
        marginTop: function() {
            return themeVars.getContentPaddingVerticalPx()
                + (this.container.get("showCloseButton")
                    ? closeButtonThemeVars.getIconSize() / 2
                    : 0);
        },

        /**
         * @returns {number} The margin in pixels
         */
        marginBottom: function() {
            return themeVars.getContentPaddingVerticalPx();
        }
    },

    /**
     * @public
     */
    theme: "bordered",

    /**
     * @private
     */
    components: [{
        classes:    "app-bookmarks-user-required-message__content",
        components: [{
            name:    "loginCta",
            kind:    LoginCta,
            classes: "app-bookmarks-user-required-message__login-cta"
        }, {
            tag:     "hr",
            classes: "app-bookmarks-user-required-message__separator"
        }, {
            name:    "signUpCta",
            kind:    SignUpCta,
            classes: "app-bookmarks-user-required-message__sign-up-cta"
        }]
    }],

    /**
     * @private
     */
    bindings: [{
        from: ".state",
        to:   ".$.loginCta.state"
    }, {
        from: ".state",
        to:   ".$.signUpCta.state"
    }]

});
